<template>
	<Card class="ly-drag-list">
		<Button slot="title" icon="md-add" @click="modalValue = true" :disabled="modeChange == 'look'">
			新增模块
		</Button>
		<RadioGroup v-model="modeChange" type="button" slot="extra">
            <Radio label="look"><Icon type="md-analytics" />浏览模式</Radio>
            <Radio label="edit"><Icon type="md-switch" />编辑模式</Radio>
        </RadioGroup>
		<div class="ly-drag-content"> 
			<ly-look :list="moduleData" v-if="modeChange == 'look'"></ly-look>
			<ly-edit :api="attrs.api" :list="moduleData" v-else></ly-edit>
			<Spin size="large" fix v-if="spinShow"></Spin>
		</div>
		<Modal
            v-model="modalValue"
            title="新增模块"
            @on-ok="addModule"
            @on-cancel="modalValue = false">
			 <Input v-model="moduleName" size="large" placeholder="模块名称" />
        </Modal>
	</Card>
</template>

<script>
	import LyLook from './look'
	import LyEdit from './edit'
  	import CompEventMixin from '@/utils/compEvent.mixin'
	import CompSendMixin from '@/utils/compSend.mixin'
	export default {
		name: "LyDragList",
		props: {
			attrs: {
                type: Object,
                default: _ => new Object()
            }
		},
    	mixins: [CompEventMixin, CompSendMixin],
		components: {
			LyLook,
			LyEdit
		},
		data () {
			return {
				spinShow: true,
				modeChange: 'edit',
				moduleData: [], // 模块的数据
				modalValue: false,
				moduleName: ''
			}
		},
		methods: {
			/**
			 * 得到page中的值后的回调函数
			 */
			pageDataCallback () {
				if (this.page) {
					this.moduleData = this.page[this.attrs.field]
					this.spinShow = false
				}
			},
			/**
			 * 有组件要提交数据的监听
			 * 这里将数据验证过后，发送要提交的数据
			 */
			handleGiveMeSubmitData () {
				// 发送需要提交的数据
				let data = {}
				data[this.attrs.field] = this.moduleData
				this.sendSubmitData(data)
			},
			addModule () {
				if (this.moduleName.length > 0) {
					this.moduleData.unshift({
						name: this.moduleName,
						modules: [],
						company: []
					})
					this.moduleName = ''
				}
			}
		}
	}
</script>
<style>
	.ly-drag-content {
		min-height: 300px;
	}
</style>



// WEBPACK FOOTER //
// ../projectCore/src/components/drag-list/src/index.vue